import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "about"
};
const _hoisted_2 = {
  class: "bg-white m-2 rounded-lg p-4"
};
const _hoisted_3 = {
  class: "text-lg mb-3 font-medium"
};
const _hoisted_4 = {
  style: {
    "color": "#f66636"
  }
};
const _hoisted_5 = {
  key: 0,
  class: "text-center"
};
const _hoisted_6 = {
  class: "text-center pb-8"
};
import { ref, computed } from 'vue';
import router from '@/router';
import { useStore } from '@/stores/pinia';
import { Toast } from 'vant';
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  __name: 'WuGong',
  setup(__props) {
    const store = useStore();
    const route = useRoute();
    const showPicker = ref(false);
    const onConfirm = value => {
      store.wg.use = value;
      showPicker.value = false;
    };
    const balance = computed(() => {
      return store.getBalance('wg');
    });
    const canSubmit = computed(() => {
      const {
        use,
        amount,
        backObjectList
      } = store.wg;
      if (!amount || !use) return false;
      for (let i = 0; i < backObjectList.length; i++) {
        if (!backObjectList[i].name) return false;
      }
      return true;
    });
    const columns = ['供斋', '供僧', '会供', '供护法', '供灯'];
    const clickAdd = () => {
      if (store.wg.backObjectList.length >= 3) return;
      store.wg.backObjectList.push({
        name: ''
      });
    };
    const clickRemove = idx => {
      store.wg.backObjectList.splice(idx, 1);
    };
    const clickSubmit = () => {
      if (balance.value < 0) return Toast.fail('余额不足');
      store.wg.isFinished = true;
      Toast.success({
        message: '提交成功',
        duration: 1000,
        onClose: router.back
      });
    };
    onMounted(() => {
      const {
        amount
      } = route.query;
      if (amount) store.wg.amount = amount;
    });
    return (_ctx, _cache) => {
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_form = _resolveComponent("van-form");
      const _component_van_picker = _resolveComponent("van-picker");
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_nav_bar, {
        title: "五供",
        "left-arrow": "",
        onClickLeft: _unref(router).back
      }, null, 8, ["onClickLeft"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("h1", _hoisted_3, [_createTextVNode(" 五供金额：¥ "), _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(balance)), 1), _createTextVNode(" 元 ")]), _createVNode(_component_van_form, {
        class: "p-0"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell_group, {
          inset: "",
          class: "m-0"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_field, {
            required: "",
            modelValue: _unref(store).wg.use,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(store).wg.use = $event),
            "is-link": "",
            readonly: "",
            name: "picker",
            label: "用途",
            placeholder: "点击选择用途",
            onClick: _cache[1] || (_cache[1] = $event => showPicker.value = true)
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            required: "",
            type: "number",
            modelValue: _unref(store).wg.amount,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(store).wg.amount = $event),
            name: "amount",
            label: "金额(¥)",
            placeholder: "请填写金额",
            rules: [{
              required: true,
              message: '请填写金额'
            }, {
              validator: v => v > 0,
              message: '五供金额需要大于0'
            }]
          }, null, 8, ["modelValue", "rules"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).wg.backObjectList, (item, idx) => {
            return _openBlock(), _createBlock(_component_van_field, {
              required: "",
              modelValue: item.name,
              "onUpdate:modelValue": $event => item.name = $event,
              name: `back-${idx}`,
              label: `回向对象${idx !== 0 ? idx + 1 : ''}`,
              placeholder: "请填写回向对象名字",
              "right-icon": idx !== 0 ? 'cross' : '',
              rules: [{
                required: true,
                message: '请填写回向对象名字'
              }],
              onClickRightIcon: $event => clickRemove(idx)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "label", "right-icon", "onClickRightIcon"]);
          }), 256))]),
          _: 1
        }), _unref(store).wg.backObjectList.length < 3 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_van_button, {
          class: "rounded-lg mt-4",
          onClick: clickAdd
        }, {
          default: _withCtx(() => [_createTextVNode("添加回向对象")]),
          _: 1
        })])) : _createCommentVNode("", true)]),
        _: 1
      })]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_button, {
        class: "submitBtn rounded-lg mt-4",
        color: "linear-gradient(45deg, #9C071E 0%, #F76F34 100%)",
        size: "large",
        disabled: !_unref(canSubmit),
        onClick: clickSubmit
      }, {
        default: _withCtx(() => [_createTextVNode(" 提交 ")]),
        _: 1
      }, 8, ["disabled"])]), _createVNode(_component_van_popup, {
        show: showPicker.value,
        "onUpdate:show": _cache[4] || (_cache[4] = $event => showPicker.value = $event),
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          columns: columns,
          onConfirm: onConfirm,
          onCancel: _cache[3] || (_cache[3] = $event => showPicker.value = false)
        })]),
        _: 1
      }, 8, ["show"])]);
    };
  }
});